<template>
  <div
    class="h-full overflow-hidden"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <template v-if="!isPlay">
      <div class="route-list-box">
        <el-collapse v-model="activeNames">
          <el-collapse-item
            :name="`${index}`"
            v-for="(route, index) in playList"
            :key="route.code + index"
          >
            <template slot="title">
              <el-checkbox v-model="route.checked" @change="routeCheckChange(route)"></el-checkbox>
              <span class="ml-5px">{{ `${route.name}(${route.code})` }}</span>
            </template>
            <div class="point-list">
              <div
                class="point-item"
                v-for="(point, index) in route.inspectPoints"
                :key="point.id"
                :id="point.id"
              >
                <div class="check-icon">
                  <el-checkbox
                    v-model="point.checked"
                    @change="pointCheckChange(route)"
                  ></el-checkbox>
                </div>
                <div
                  class="cursor-pointer point-item-info"
                  :class="{ 'cur-point': curPointInfo.id === point.id }"
                >
                  {{ index + 1 }}: {{ point.name }} ({{ point.code }})
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="flex justify-between">
        <el-select v-model="inspectMode" class="w-136px" popper-class="visualization-select-popper">
          <el-option label="漫游模式" value="hard"></el-option>
          <el-option label="速览模式" value="easy"></el-option>
        </el-select>
        <el-button type="primary" class="w-96px" @click="playHandle" :loading="playLoading"
          >播放</el-button
        >
      </div>
    </template>
    <template v-else>
      <inspectScreen
        v-show="inspectMode === 'hard'"
        @sendInfoToRightDialog="sendInfoToRightDialog"
        @endHandle="endHandle"
        :playInfo="playInfo"
        :player="player"
        :cloudRender="cloudRender"
        :showAlarmBlink="showAlarmBlink"
      ></inspectScreen>
      <inspectScreenEasy
        v-if="inspectMode !== 'hard'"
        @sendInfoToRightDialog="sendInfoToRightDialog"
        @endHandle="endHandle"
        :playInfo="playInfo"
        :player="player"
        :cloudRender="cloudRender"
        :showAlarmBlink="showAlarmBlink"
      ></inspectScreenEasy>
    </template>
  </div>
</template>

<script>
import { InspectRouteApi } from '@wiz-api/roam-inspect-management'
import inspectScreen from './inspectScreen'
import inspectScreenEasy from './inspectScreenEasy'

const inspectRouteApi = new InspectRouteApi()

export default {
  name: 'inspectRoute',
  components: {
    inspectScreen,
    inspectScreenEasy,
  },
  props: {
    /** 场景id */
    sourceId: {
      type: String,
      defalut: '',
    },
    player: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    labelList: {
      type: Array,
      defalut: () => {
        return []
      },
    },
    customProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    return {
      loading: false,
      playList: [],
      markerImgId: '',
      markerTextImgId: '',
      markerList: [],
      markerIdList: [],
      textMarkerIdList: [],
      curPointInfo: {},
      routeShow: false,
      activeNames: ['0'],
      inspectMode: 'hard',
      isPlay: false,
      playInfo: {},
      showAlarmBlink: true,
      playLoading: false,
      piId: '',
    }
  },
  watch: {
    transferProps: {
      handler(data) {
        if (data?.returnBack) {
          this.isPlay = false
        } else if (data?.alarmSet) {
          // 报警闪烁设置
          this.showAlarmBlink = data.showAlarmBlink
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    setCheckDisable(bol) {
      const disableEvent = new CustomEvent('setCheckDisable', {
        detail: {
          disable: bol,
        },
      })
      window.dispatchEvent(disableEvent)
    },
    setLabelUncheck() {
      const newLabelList = _.map(this.labelList, (item) => {
        const obj = _.cloneDeep(item)
        obj.checked = false
        return obj
      })
      const hiddenList = _.filter(this.labelList, (item) => {
        return item.checked
      })
      const hiddenEvent = new CustomEvent('setComponentVisible', {
        detail: {
          type: 'hidden',
          hiddenList,
          newLabelList,
        },
      })
      window.dispatchEvent(hiddenEvent)
    },
    endHandle() {
      this.isPlay = false
      this.sendInfoToRightDialog('close')
      this.backInitPositon()
    },
    // 传递信息给二级弹框
    sendInfoToRightDialog(type, data = {}) {
      this.$emit('transferEvent', {
        toCom: { code: 'InspectRight', origin: 'InspectRoute', name: '报警信息面板' },
        type,
        props: data,
      })
    },
    // 路线切换选中
    routeCheckChange(route) {
      route.inspectPoints.forEach((item) => {
        item.checked = route.checked
      })
    },
    // 巡检点切换选中
    pointCheckChange(route) {
      const notCheck = route.inspectPoints.some((item) => {
        return !item.checked
      })
      if (notCheck) {
        route.checked = false
      } else {
        const checkAll = route.inspectPoints.every((item) => {
          return item.checked
        })
        if (checkAll) {
          route.checked = true
        }
      }
    },
    async getRouteList() {
      this.loading = true
      const [err, res] = await inspectRouteApi.getList({
        sceneId: this.sourceId,
        status: true,
        skipCount: 0,
        maxResultCount: 99,
      })
      if (!err) {
        const routeIds = res.items.map((item) => {
          return item.id
        })
        await this.getPointList(routeIds)
      }
      this.loading = false
    },
    async getPointList(routeIds) {
      const [err, res] = await inspectRouteApi.getInspectRouteList({
        body: routeIds,
      })
      if (!err) {
        res.forEach((route) => {
          route.checked = true
          if (route.inspectPoints) {
            route.inspectPoints.sort((a, b) => {
              return a.seqNo - b.seqNo
            })
            route.inspectPoints.forEach((item) => {
              item.pos = [item.xPoint, item.yPoint, item.zPoint]
              item.checked = true
              if (item.cameras?.length && !this.piId) {
                this.piId = item.cameras[0].piId
              }
            })
          }
        })
        this.playList = res
      }
    },
    // 播放
    async playHandle() {
      this.playLoading = true
      let flag = false
      const playList = JSON.parse(JSON.stringify(this.playList))
      const routeList = []
      playList.forEach((route) => {
        const { inspectPoints, ...res } = route
        const points = []
        inspectPoints.forEach((item) => {
          if (item.checked) {
            points.push(item)
            flag = true
          }
        })
        if (points.length) {
          res.inspectPoints = points
          routeList.push(res)
        }
      })
      if (!flag) {
        this.$message.error('请选择巡检点')
        this.playLoading = false
        return
      }
      const ids = routeList.map((item) => {
        return item.id
      })
      const [err, res] = await inspectRouteApi.inspectRoutePlay({
        body: ids,
      })
      if (!err) {
        this.playInfo = {
          batchNo: res,
          routeIds: ids,
          routePoints: routeList,
        }
        this.isPlay = true
        // 打开二级弹框
        this.sendInfoToRightDialog('mainComponent', {
          piId: this.piId,
        })
      }
      this.playLoading = false
    },
    // 返回初始视角
    backInitPositon() {
      if (this.customProps?.sceneOptions?.jsonData) {
        const jsonData = JSON.parse(this.customProps.sceneOptions.jsonData)
        const cameraParams = jsonData.cameraParams
          ? JSON.parse(jsonData.cameraParams)
          : { eye: [-1028, 580, 13821], target: [-1028, 579, 85], up: [0, 1, 0] }
        this.cloudRender.Camera.moveCamera('CameraParam', cameraParams)
      }
    },
  },
  created() {
    this.getRouteList()
    this.setLabelUncheck()
    this.setCheckDisable(true)
  },
  beforeDestroy() {
    this.sendInfoToRightDialog('close')
    this.setCheckDisable(false)
    this.backInitPositon()
  },
}
</script>

<style lang="scss" scoped>
.route-list-box {
  overflow: auto;
  padding: 0 10px;
  margin: 10px 0;
  height: calc(100% - 63px);

  .point-list {
    padding-left: 12px;

    .point-item {
      display: flex;
      padding: 1px 0;
      min-height: 26px;

      .check-icon {
        margin-right: 5px;
      }

      .cur-point {
        color: #03fd38;
      }
    }
  }

  ::v-deep .el-collapse {
    border-top: transparent;
    border-bottom: transparent;

    .el-collapse-item {
      margin-bottom: 5px;
    }

    .el-collapse-item__header {
      padding-left: 10px;
      height: 36px;
      color: #fff;
      background: transparent;
      border: 1px solid #0e7a84;
      line-height: 36px;
    }

    .el-collapse-item__arrow.el-icon-arrow-right {
      color: #fff;
    }

    .el-collapse-item__wrap {
      color: #fff;
      background-color: transparent;
      border-bottom: transparent;
    }

    .el-collapse-item__content {
      padding: 10px;
      margin-top: 5px;
      color: #fff;
      border: 1px solid #0e7a84;
    }
  }
}
</style>
